
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anki-ai-image-occlusion",
      function () {
        return require("private-next-pages/anki-ai-image-occlusion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anki-ai-image-occlusion"])
      });
    }
  